import { useState, useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import _ from 'lodash'
import { Loader } from 'Common/Loader/Loader'
import {
  StyledFooter,
  StyledModal,
  ModalBody,
  ModalActionButton,
  AccordionsWrapper,
} from './WorkcentreModal.styles'
import { Accordions } from './Accordions/Accordions.view'
import { WorkcentreModalProps } from './WorkcentreModal.types'
import { SourceSiteSelectionControl } from './SourceSiteSelectionControl/SourceSiteSelectionControl.view'
import {
  isAnyWorkCentresSelected,
  isAnySourceSitesSelected,
} from './WorkcentreModal.utils'

export const WorkcentreModal = ({
  isModalOpen,
  handleModalClose,
  sourceSiteData,
  handleOkbuttonClick,
  readOnly,
  isUpdating,
}: WorkcentreModalProps) => {
  const [sourceSiteDetails, setSourceSiteDetails] = useState(sourceSiteData)

  useEffect(() => {
    setSourceSiteDetails(sourceSiteData)
  }, [sourceSiteData])

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    sourceSiteName?: string,
    workcentreName?: string
  ) => {
    const updatedData = sourceSiteDetails.map((sourcesite) => {
      if (sourceSiteName === sourcesite.siteLabel || !sourceSiteName) {
        const workcentres = sourcesite.siteWorkcentres.map((workcentre) => {
          if (
            (workcentreName && workcentre.code === workcentreName) ||
            !workcentreName ||
            !sourceSiteName
          ) {
            return {
              ...workcentre,
              isSelected: event.target.checked,
            }
          } else return workcentre
        })
        return {
          ...sourcesite,
          isSelected: isAnyWorkCentresSelected(workcentres),
          siteWorkcentres: workcentres,
        }
      } else return sourcesite
    })
    setSourceSiteDetails(updatedData)
  }

  const Body = (
    <ModalBody readOnly={readOnly}>
      {!readOnly && (
        <SourceSiteSelectionControl
          sourceSiteDetails={sourceSiteDetails}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
      <AccordionsWrapper readOnly={readOnly}>
        <Accordions
          readOnly={readOnly}
          sourceSiteDetails={sourceSiteDetails}
          handleCheckboxChange={handleCheckboxChange}
        />
      </AccordionsWrapper>
    </ModalBody>
  )

  const isSourceSiteDetailsEdited = () => {
    return !_.isEqual(sourceSiteDetails, sourceSiteData)
  }

  const Loading = (
    <ModalBody readOnly={readOnly}>
      <Loader />
    </ModalBody>
  )

  const Footer = (
    <StyledFooter>
      <ModalActionButton
        onClick={handleModalClose}
        variant="outlined"
        label="Cancel"
        disabled={isUpdating}
      >
        Cancel
      </ModalActionButton>
      <ModalActionButton
        disabled={
          !isAnySourceSitesSelected(sourceSiteDetails) ||
          isUpdating ||
          !isSourceSiteDetailsEdited()
        }
        variant="contained"
        onClick={() => handleOkbuttonClick(sourceSiteDetails)}
        label="Ok"
      >
        {isUpdating && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{
              marginRight: '8px',
            }}
          />
        )}
        Ok
      </ModalActionButton>
    </StyledFooter>
  )

  return (
    <StyledModal
      aria-labelledby={readOnly ? 'View work centres' : 'Select work centres'}
      open={isModalOpen}
      handleClose={handleModalClose}
      header={readOnly ? 'View work centres' : 'Select work centres'}
      body={sourceSiteData.length > 0 ? Body : Loading}
      footer={!readOnly && Footer}
      isHeaderCloseButtonDisabled={isUpdating}
    />
  )
}
